module.exports = __webpack_public_path__ + "static/media/Sixth.4cc0c205.png";